import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { useEnviarOrcamento } from '@/hooks/useSolicitacoes';

interface Props {
  solicitacaoId: string | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function EnviarOrcamentoDialog({ solicitacaoId, open, onOpenChange }: Props) {
  const { t } = useTranslation();
  const enviar = useEnviarOrcamento();
  const [valor, setValor] = useState('');
  const [mensagem, setMensagem] = useState('');

  useEffect(() => {
    if (open) { setValor(''); setMensagem(''); }
  }, [open]);

  const valorNum = Number(valor.replace(',', '.'));
  const podeEnviar = !!solicitacaoId && valorNum > 0 && !enviar.isPending;

  const onSubmit = async () => {
    if (!solicitacaoId) return;
    await enviar.mutateAsync({ solicitacaoId, valor: valorNum, mensagem: mensagem.trim() || undefined });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader><DialogTitle>{t('solicitacoes.dialogTitle')}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label htmlFor="orc-valor">{t('solicitacoes.value')}</Label>
            <Input id="orc-valor" inputMode="decimal" value={valor} onChange={(e) => setValor(e.target.value)} />
          </div>
          <div>
            <Label htmlFor="orc-msg">{t('solicitacoes.message')}</Label>
            <Textarea id="orc-msg" value={mensagem} onChange={(e) => setMensagem(e.target.value)} placeholder={t('solicitacoes.messagePlaceholder')} rows={3} />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={onSubmit} disabled={!podeEnviar}>{t('solicitacoes.submit')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
